module.exports = __webpack_public_path__ + "static/media/napas247.d1ce9821.png";